import { StyleSheet, View, ViewStyle } from "react-native";
import { Colors } from "../../styles";

const Divider = ({ style }: { style?: ViewStyle }) => {
  return <View style={[styles.divider, style]} />;
};

const styles = StyleSheet.create({
  divider: {
    height: 1,
    width: "100%",
    backgroundColor: Colors.plum500,
  },
});

export default Divider;
